import { checkModuleEnabled } from 'utils/helpers/moduleAccess';

import { TASK_TYPES_2 } from 'constants/ProjectConstants';

const TASK_TYPES = [
  { name: 'Initiatives', value: TASK_TYPES_2.task },
  { name: 'Goals', value: TASK_TYPES_2.goal },
];

export const getEnabledTaskTypeMenuItems = () => TASK_TYPES.filter(({ value }) => checkModuleEnabled(value));

export const getEnabledTaskTypeMenuItemsForDefaultOption = () =>
  [TASK_TYPES_2.goal, TASK_TYPES_2.task]
    .map((tt) => ({
      name: `${tt.underscoreLess().toProperCase()}s`,
      value: tt,
    }))
    .filter(({ value }) => checkModuleEnabled(value));

export function findAncestor(el, cls) {
  while ((el = el.parentNode) && el.className.indexOf(cls) < 0);
  return el;
}
